/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper';

export default declareEntity({
    entity: "eventDetectors",
    graphQL: "eventDetector",
    name: "Store Info",
    dynamoPrefix: 'sys',
    storageType: 'silo',
    userEditable: false,
    fields: (types) => { return {
        id: {
            name: "Event Detector ID",
            type: "string",
            id: true,
            defaultValue: () => {
                return uuidv4();
            },
            required: true,
            primaryKey: true,
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            required: true,
            defaultValue: (parent) => {
                return parent['channel_id'];
            },
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            defaultValue: (parent) => {
                return parent['channelDef_id'];
            },
            required: true
        },
        sourceDef: {
            name: "Source Definition",
            type: "relation",
            to: () => types['sourceDefs'],
            defaultValue: (parent) => {
                return parent['sourceDef_id'];
            },
            relativeTo: ['channelDef'],
            required: true
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (parent) => {
                return parent['organisation_id'];
            },
            required: true
        },
        content: {
            name: "Content",
            type: "object",
            defaultValue: {},
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; }
});
